import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { OpportunityForm } from "@/components/opportunities/OpportunityForm";
import { Clock } from "lucide-react";

interface CreateOpportunityStepProps {
  onComplete: () => void;
  onSkip: () => void;
}

export const CreateOpportunityStep = ({ onComplete, onSkip }: CreateOpportunityStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-semibold mb-2">
          {t('onboarding.createOpportunity.title')}
        </h2>
        <p className="text-muted-foreground">
          {t('onboarding.createOpportunity.description')}
        </p>
      </div>

      <OpportunityForm onSuccess={onComplete} />

      <div className="flex justify-center">
        <Button
          variant="ghost"
          onClick={onSkip}
          className="mt-4"
        >
          <Clock className="w-4 h-4 mr-2" />
          {t('onboarding.doItLater')}
        </Button>
      </div>
    </div>
  );
};